import request from '../utils/request.js'

export default {
  getFields (params) {
    return request.post(`jobs/getFields`, params).then(res => res.data)
  }

}



// WEBPACK FOOTER //
// ./src/api/condition.js